export default "__VITE_ASSET__DQFBPUi3__"